import React, { useState } from "react";
import { useDispatch } from "react-redux";
import AdmissionGuideline from "../../components/admission/AdmissionGuideline.js";
import AdmissionFormSteps from "../../components/admission/admissionForm/index.js";
import { Helmet } from "react-helmet";

export default function AdmissionForm() {
  const [showGuidelines, setShowGuidelines] = useState(false);
  const handleToggleGuideline = () => {
    setShowGuidelines(!showGuidelines);
  };
  React.useEffect(() => {
    setShowGuidelines(true);
  }, []);

  return (
    <div className="bg-light ">
      <Helmet>
        <title>Admission Form - Firdaus-Gate Model Schools</title>
        <meta
          name="description"
          content="Complete your admission application for Firdaus-Gate Model Schools. Fill out the admission form online."
        />
        <meta name="robots" content="noindex, nofollow" />
        <link
          rel="canonical"
          href="https://www.firdaus-gate.com/admission/admission-form"
        />
      </Helmet>
      <div className="">
        {showGuidelines && (
          <AdmissionGuideline
            onToggle={handleToggleGuideline}
            isShow={showGuidelines}
          />
        )}

        <AdmissionFormSteps />
      </div>
    </div>
  );
}
